<template>
    <div class="vcwrap">
        <Multicorder :class="[showselect?'myvc2':'myvc']" :video-source="videoSource"
                     @error="onError"
                     @cameras="onCameras"
                     @video-live="onVideoLive"
                     @view-change="onViewChange"
                     @new-recording="onNewRecording"
                     @delete-recording="onDeleteRecording"
                     @player-loaded="onPlayerLoaded"
                     ref="multicorder"
                     :videoTypes="videoTypes"
                     :recorderMode="recorderMode" />
        <el-select v-model="videoSource" @change="setcamera" v-if="showselect">
            <el-option v-for="item in videoSourceList" :key="item.value" :label="item.text" :value="item"></el-option>
        </el-select>
    </div>

</template>

<script>
    /**
     * For Hot reload load the `*.vue` files from the parent `/src/` directly.
     */
    import { Multicorder } from "multicorder";
    // import { Multicorder } from "../../../src/lib-components/index.js";

    export default {
        name: "Crecordervideo",
        components: {
            Multicorder
        },
        props: {
            videoTypes: {
                type: Array,
                default: () => {
                    return ["camera"];
                },
            },
            recorderMode: {
                type: String,
                default: "single",
            },
            showselect: {
                type: Boolean,
                default: false
            },
            hascamera: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                controls: null,
                videoSource: null,
                videoSourceList: [],
                isPaused: false,
                isPlayerPaused: false,
                isMuted: true,
                isPlayerMuted: true,
                view: "video",
                recordings: [] // local sparsed list of recording data
            };
        },
        methods: {
            onError: function () {
                //console.log("Error emitted", error);
                this.$common.alert('未找到摄像头');
            },
            onCameras: function (cameras) {
                //console.log("Available cameras", cameras);
                /**
                 * We are implementing a `multicorder` with camera and screen support.
                 * We need to create a list that groups the items for a `v-select` component.
                 * We use the `listFromCameras` helper function provided by the component.
                 * The Multicorder component maintains a list of `cameras` if we need them independently.
                 */
                this.videoSourceList = this.$refs.multicorder.listFromCameras(cameras);
                if (cameras.length == 0) {
                    this.$common.alert('请配置摄像头');

                }
                else {
                    this.$emit('update:hascamera', true);
                    let selectcameta = this.$common.basic.fffind(cameras, 'value', this.$store.state.cameraid);
                    if (this.$common.basic.isobjexist(selectcameta)) {
                        this.videoSource = selectcameta;
                    }
                    else {
                        this.videoSource = cameras[0];
                        this.setcamera();
                    }

                }
            },
            onVideoLive: function () {
                this.controls = "liveVideo";
            },
            onViewChange: function (view) {
                this.view = view;
            },
            onNewRecording: function (recording) {
                this.recordings.push(recording);
                if (this.recorderMode == "single") {
                    // Load the video into the player and force disposition
                    // this.view = "videoPlayer";
                    this.loadRecording(0);
                }
            },
            onDeleteRecording: function (index) {
                this.recordings.splice(index, 1);
                if (this.recorderMode == "single") {
                    this.controls = "liveVideo"
                }
            },
            onPlayerLoaded: function () {
                //this.playRecording();
            },
            videoRecord: function () {
                this.controls = "recordingVideo";
                this.$refs.multicorder.startVideoRecording();
            },
            videoSnapshot: function (fromView) {
                this.$refs.multicorder.videoSnapshot(fromView);
            },
            videoClose: function () {
                this.$refs.multicorder.stopVideo();
                this.view = "video";
                this.controls = "liveVideo";
                this.videoSource = null;
            },
            videoStopRecording: function () {
                this.$refs.multicorder.stopRecording();
                // resume the video, minus recording
                this.resume();
            },
            resume: function () {
                this.isPaused = false;
                this.$refs.multicorder.resume();
            },
            pause: function () {
                this.isPaused = true;
                this.$refs.multicorder.pause();
            },
            closeSnapshot: function () {
                this.$refs.multicorder.closeSnapshot();
            },
            snapshotDownload: function () {
                this.$refs.multicorder.downloadSnapshot();
            },
            downloadRecording: function (index) {
                if (this.recorderMode === 'single') {
                    index = 0;
                }
                this.$refs.multicorder.downloadRecording(index);
            },
            deleteRecording: function (index) {
                if (this.recorderMode === 'single') {
                    index = 0;
                }
                this.$refs.multicorder.deleteRecording(index);
            },
            async loadRecording(index) {
                await this.$refs.multicorder.loadRecording(index);
            },
            playRecording: function () {
                this.isPlayerPaused = false;
                this.$refs.multicorder.playRecording();
            },
            pausePlayer: function () {
                this.isPlayerPaused = true;
                this.$refs.multicorder.pausePlayer();
            },
            resumePlayer: function () {
                this.isPlayerPaused = false;
                this.$refs.multicorder.resumePlayer();
            },
            deletePlayerRecording: function () {
                this.$refs.multicorder.deletePlayerRecording();
            },
            closePlayer: function () {
                this.$refs.multicorder.closePlayer();
            },
            toggleMuted: function () {
                this.isMuted = !this.isMuted;
            },
            togglePlayerMuted: function () {
                this.isPlayerMuted = !this.isPlayerMuted;
            },

            getphoto: function () {

                this.videoSnapshot(this.view);
                let img = this.$refs.multicorder.snapshot;
                this.closeSnapshot();
                return img;
            },
            setcamera: function () {
                this.$store.commit('SET_CAMERAID', this.videoSource.value);
            }
        },
    };
</script>

<style scoped>
    .vcwrap { width: 100%; height: 100%; flex-flow: column nowrap }
        .vcwrap .myvc { width: 100%; height: 100% }
        .vcwrap .myvc2 { width: 100%; height: calc(100% - 40px) }
    .vcselect { width: 100%; }
</style>
